import { Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { StartAuditComponent } from "./start-audit/start-audit.component";
import { SelectLocationComponent } from "./select-location/select-location.component";
import { AuditMainComponent } from "./audit-main/audit-main.component";
import { TestpageComponent } from "./testpage/testpage.component";
import { SettingsComponent } from "./settings/settings.component";
import { SelectAuditEditComponent } from "./settings/manageaudits/select-audit-edit/select-audit-edit.component";
import { EditAuditComponent } from "./settings/manageaudits/edit-audit/edit-audit.component";
import { ActionsComponent } from "./actions/actions.component";
import { DiaryComponent } from "./diary/diary.component";
import { ResultsHomeComponent } from "./results-home/results-home.component";
import { ExistingUsersComponent } from "./settings/manageusers/existing-users/existing-users.component";
import { GroupManagementComponent } from "./settings/manageusers/group-management/group-management.component";
import { NewUserComponent } from "./settings/manageusers/new-user/new-user.component";
import { NewUserWizardComponent } from "./settings/manageusers/new-user-wizard/new-user-wizard.component";
import { AssignAuditsComponent } from "./settings/manageaudits/assign-audits/assign-audits.component";
import { AssignLocationsComponent } from "./settings/managelocations/assign-locations/assign-locations.component";
import { EditLocationComponent } from "./settings/managelocations/edit-location/edit-location.component";
import { NewLocationWizardComponent } from "./settings/managelocations/new-location-wizard/new-location-wizard.component";
import { CurrentUsersComponent } from "./settings/manageusers/current-users/current-users.component";
import { UserProfileComponent } from "./settings/manageusers/user-profile/user-profile.component";
import { UserAuditsComponent } from "./settings/manageusers/user-audits/user-audits.component";
import { AssignLocationAuditsComponent } from "./settings/managelocations/assign-location-audits/assign-location-audits.component";
import { AuditlocationsComponent } from "./settings/manageaudits/auditlocations/auditlocations.component";
import { AuditusersComponent } from "./settings/manageaudits/auditusers/auditusers.component";
import { ReportsComponent } from "./reports/reports.component";
import { TasksComponent } from "./tasks/tasks.component";
import { CustomerSupportComponent } from "./settings/customer-support/customer-support.component";
import { UserLocationsComponent } from "./settings/manageusers/user-locations/user-locations.component";
import { NewCampaignComponent } from "./settings/campaigns/new-campaign/new-campaign.component";
import { CampaignListComponent } from "./settings/campaigns/campaign-list/campaign-list.component";
import { EventQuestionEditComponent } from "./event-question-edit/event-question-edit.component";
import { EventsComponent } from "./events/events.component";
import { EventPageComponent } from "./event-page/event-page.component";
import { ActionDetailV2Component } from "./action-detail-v2/action-detail-v2.component";
import { WorkflowsComponent } from "./settings/events/workflows/workflows.component";
import { WorkflowActionsComponent } from "./settings/events/workflows/workflow-actions/workflow-actions.component";
import { RetrieveAuditComponent } from "./settings/retrieve-audit/retrieve-audit.component";
import { EventTemplatesComponent } from "./settings/events/event-templates/event-templates.component";
import { EventTemplateDetailComponent } from "./settings/events/event-template-detail/event-template-detail.component";
import { UserEditComponent } from "./settings/manageusers/user-edit/user-edit.component";
import { DashboardPageComponent } from "./dashboards/dashboard-page/dashboard-page.component";


export const SECURE_ROUTES: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'startaudit', component: StartAuditComponent },
    { path: 'actions', component: ActionsComponent },
    { path: 'events', component: EventsComponent },
    { path: 'events/:id', component: EventPageComponent },
    { path: 'actionv2', component: ActionDetailV2Component },
    { path: 'event-question-edit', component: EventQuestionEditComponent },
    { path: 'selectlocation', component: SelectLocationComponent },
    { path: 'audit', component: AuditMainComponent },
    { path: 'settings', component: SettingsComponent },
    { path: 'results', component: ResultsHomeComponent },
    { path: 'reports', component: ReportsComponent },
    { path: 'dashboards', component: DashboardPageComponent },
    { path: 'dashboards/:dashboardId', component: DashboardPageComponent },
    { path: 'tasks', component: TasksComponent },
    { path: 'settings/manage/edit', component: SelectAuditEditComponent },
    { path: 'settings/manage/edit/audit', component: EditAuditComponent },
    { path: 'settings/manage/new/audit', component: EditAuditComponent },
    { path: 'settings/manage/assignaudit', component: AssignAuditsComponent },
    { path: 'settings/manage/audit/locations', component: AuditlocationsComponent },
    { path: 'settings/users/existing', component: ExistingUsersComponent },
    { path: 'settings/users/usermanagement', component: CurrentUsersComponent },
    { path: 'settings/users/existinggroups', component: ExistingUsersComponent },
    { path: 'settings/users/profile', component: UserProfileComponent },
    { path: 'settings/users/groups', component: GroupManagementComponent },
    { path: 'settings/users/edit', component: UserEditComponent },
    { path: 'settings/users/newuser', component: NewUserComponent },
    { path: 'settings/users/newuserwizard', component: NewUserWizardComponent },
    { path: 'settings/users/newgroup', component: NewUserComponent },
    { path: 'settings/users/useraudits', component: UserAuditsComponent },
    { path: 'settings/users/groupaudits', component: UserAuditsComponent },
    { path: 'settings/locations/assignlocations', component: AssignLocationsComponent },
    { path: 'settings/locations/assigngrouplocations', component: AssignLocationsComponent },
    { path: 'settings/locations/editlocation', component: EditLocationComponent },
    { path: 'settings/locations/newlocation', component: EditLocationComponent },
    { path: 'settings/locations/newlocationwizard', component: NewLocationWizardComponent },
    { path: 'diary', component: DiaryComponent },
    { path: 'test', component: TestpageComponent },
    { path: 'settings/locations/assignlocationaudits', component: AssignLocationAuditsComponent },
    { path: 'settings/locations/assignuseraudits', component: AuditusersComponent },
    { path: 'settings/customersupport', component: CustomerSupportComponent },
    { path: 'settings/retrieveaudit', component: RetrieveAuditComponent },
    { path: 'settings/users/locations', component: UserLocationsComponent },
    { path: 'settings/campaigns/newcampaign', component: NewCampaignComponent },
    { path: 'settings/campaigns/campaignlist', component: CampaignListComponent },
    { path: 'settings/events/workflows', component: WorkflowsComponent },
    { path: 'settings/events/workflows/:id', component: WorkflowActionsComponent },
    { path: 'settings/events/templates', component: EventTemplatesComponent },
    { path: 'settings/events/templates/:id', component: EventTemplateDetailComponent }
    
];
